
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/* global Vue */

// Import dependencies
import VueInternationalization      from 'vue-i18n';
import Locale                       from '../js/vue-i18n-locales.generated';
import BootstrapVue                 from 'bootstrap-vue';
import VueMq                        from 'vue-mq';
import VueTour                      from 'vue-tour';
import Vuex                         from 'vuex';
import VuexPersistence              from 'vuex-persist';
import Notifications                from 'vue-notification';
import VueSweetalert2               from 'vue-sweetalert2';
import Toasted                      from 'vue-toasted';
import VueClip                      from 'vue-clip';
import Multiselect                  from 'vue-multiselect';
import VueContentPlaceholders       from 'vue-content-placeholders';

require('vue-tour/dist/vue-tour.css');
Vue.use(VueSweetalert2);
Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(VueInternationalization);
Vue.use(VueMq);
Vue.use(Notifications);
Vue.use(VueTour);

// Make sure to call Vue.use(Vuex) first if using a module system
const vuexLocal = new VuexPersistence({
    storage: window.localStorage
});

const store = new Vuex.Store({
    state: {
        tour: false
    },
    mutations: {
        tourDidEnd (state) {
            state.tour = true;
        },
        tourStart (state) {
            state.tour = false;
        }
    },
    plugins: [vuexLocal.plugin]
});

// Define lang variables
const lang = document.documentElement.lang.substr(0, 2);
const i18n = new VueInternationalization({
    locale: (Locale[lang] !== undefined) ? lang : 'it',
    messages: Locale
});

Vue.use(require('vue-moment'));
Vue.use(Toasted);
Vue.toasted.register('error', message => message, {
    position : 'bottom-center',
    duration : 1000
});
Vue.use(VueClip);
Vue.component('multiselect', Multiselect)
Vue.use(VueContentPlaceholders)


// Load VUE components to use in blade
require('./components/components_loader');

// Require full parent from windows helper
import fullParent from './WindowHelper/index';

// Event bus
import EventBus from './EventBus';

new Vue({
    el: '#app',
    i18n,
    store
});

/* global $ */
$(document).ready(function(){

    //Enable tooltip everywhere
    $('[data-toggle="tooltip"]').tooltip();

    setTimeout(() => fullParent(), 600);

    $(window).resize(function() {
        EventBus.$emit('WINDOW_RESIZING');
        fullParent();
        clearTimeout(window.resizedFinished);
        window.resizedFinished = setTimeout(function(){
            fullParent();
            EventBus.$emit('WINDOW_DID_RESIZE');
        }, 250);
    });

    // Event for hamburger menu toggle
    $('.navbar-toggler').on('click', function(){
        if (localStorage.getItem('hamburgerMinimized')) {
            localStorage.removeItem('hamburgerMinimized');
            EventBus.$emit('SIDE_BAR_EXPANDED');
        } else {
            localStorage.setItem('hamburgerMinimized', true);
            EventBus.$emit('SIDE_BAR_MINIMIZED');
        }
    });

});
